export default "__VITE_ASSET__074b89b4__"